import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import React, { useState } from "react";
import { getNarrativeTypeColor } from "utils/styles";
import Button from "components/Button";
import Icon from "./Icon";
import PostAvatar from "./PostAvatar";
import PostInfo from "./PostInfo";
import styled from "styled-components";
import AudienceEmoji from "components/AudienceEmoji";
import { getLongNarrativeDescription } from "posts/constants";

const Wrapper = styled.div`
  max-width: 500px;
  margin: 0 auto;
`;

const PostFooterContainer = styled.div`
  display: grid;
  grid-column-gap: 11px;
  grid-template-columns: ${({ hasAvatar }) =>
    hasAvatar ? "30px 1fr 0px" : "1fr 0px"};
  align-items: top;
  margin-right: -5px;
  margin-top: 20px;
  position: relative;
`;

const ExploreContainer = styled.div`
  display: flex;
  flex: row;
  flex-content: center;
  position: absolute;
  top: -55px;
  right: 10px;
`;

const AudienceEmojiWrapper = styled.span`
  display: block;
  line-height: 1;
  justify-self: center;
  align-self: center;
  cursor: default;
`;

const NarrativeLabel = styled.span.attrs({
  className: "mabry-medium",
})`
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-bottom: 4px;
  display: block;
  align-self: center;
`;

const NarrativeButton = styled.button`
  appearance: none;
  background: transparent;
  margin: 0;
  padding: 0;
  border: none;
  outline: none;

  &:focus,
  &:active {
    outline: none;
    border: none;
  }
`;

export default function PostFooter(props) {
  const { audiences, povertyNarratives, type } = props;
  const renderAudienceIcons = () => {
    if (!audiences || !audiences.length) return null;
    return audiences.map((audienceType, index) => {
      return (
        <div key={`audience-icon-${index}`}>
          <OverlayTrigger
            key="top"
            placement="top"
            overlay={<Tooltip id={`tooltip-${"top"}`}>{audienceType}</Tooltip>}
          >
            <div>
              <Icon additionalClasses="pt3">
                <AudienceEmojiWrapper>
                  <AudienceEmoji noMarginRight audience={audienceType} />
                </AudienceEmojiWrapper>
              </Icon>
            </div>
          </OverlayTrigger>
        </div>
      );
    });
  };

  const [narrativePopupType, setNarrativePopupType] = useState(null);
  const renderNarrativeModalContent = () => {
    const paragraphs = getLongNarrativeDescription(narrativePopupType) || [];
    return (
      <div>
        {paragraphs.map((p, i) => (
          <p key={`narrative-modal-paragraph-${i}`}>{p}</p>
        ))}
        <Button className="mt-3 mb-3" href="/narratives">
          See All Narratives
        </Button>
      </div>
    );
  };
  const renderNarratives = () => {
    if (!povertyNarratives || !povertyNarratives.length) return null;
    return (
      <>
        {povertyNarratives.map((narrative, index) => {
          return (
            <div key={`narrative-icon-${index}`}>
              <NarrativeButton onClick={() => setNarrativePopupType(narrative)}>
                <Icon
                  padLeft
                  iconType="category"
                  iconColor={getNarrativeTypeColor(narrative)}
                  additionalClasses="pt3"
                >
                  <NarrativeLabel>{narrative}</NarrativeLabel>
                </Icon>
              </NarrativeButton>
            </div>
          );
        })}
        <Modal
          centered
          show={Boolean(narrativePopupType)}
          onHide={() => {
            setNarrativePopupType(null);
          }}
        >
          <Modal.Header closeButton>{narrativePopupType}</Modal.Header>
          <Modal.Body>{renderNarrativeModalContent()}</Modal.Body>
        </Modal>
      </>
    );
  };

  let postAvatarContent;
  if (type !== "twitter") {
    postAvatarContent = <PostAvatar {...props} />;
  }

  let postInfoContent;
  if (type !== "twitter") {
    postInfoContent = <PostInfo {...props} />;
  }

  return (
    <Wrapper>
      <PostFooterContainer hasAvatar={Boolean(props.avatar)}>
        {postAvatarContent}
        {postInfoContent}
        <ExploreContainer>
          {renderAudienceIcons()}
          {renderNarratives()}
        </ExploreContainer>
      </PostFooterContainer>
    </Wrapper>
  );
}
